/**
 * Shape for a single segment (label + color). Keys are generic for any metric set.
 */
export interface ProgressSegmentShape {
    key: string;
    label: string;
    color: string;
}

export interface GroupedProgressMeterProps {
    /** Segments in display order (left to right). */
    segments: ProgressSegmentShape[];
    /** Percentage (0–100) per segment key. Segment not rendered if missing or 0. */
    percentages: Record<string, number>;
    /** Count per segment key (for tooltips). */
    counts: Record<string, number>;
}

export const GroupedProgressMeter = ({ segments, percentages, counts }: GroupedProgressMeterProps) => (
    <div className="grouped-progress__meter">
        {segments.map((seg) => {
            const pct = percentages[seg.key] ?? 0;
            const count = counts[seg.key] ?? 0;
            if (pct <= 0) {
                return null;
            }
            return (
                <div
                    key={seg.key}
                    className="grouped-progress__segment"
                    style={{ width: `${pct}%`, backgroundColor: seg.color }}
                    title={`${seg.label}: ${count}`}
                >
                    {pct >= 10 && (
                        <span className="grouped-progress__segment-label">{pct}%</span>
                    )}
                </div>
            );
        })}
    </div>
);

export default GroupedProgressMeter;
